module.exports = {
    acesso: 'Acesso',
    acessoMoodle: 'Acesso Moodle',
    acessoPacs: 'Acesso PACS',
    habilitadoAcessoMoodle: 'Habilitado acesso ao Moodle',
    habilitadoAcessoPacs: 'Habilitado acesso ao PACS',
    ipCadastrado: 'IP cadastrado',
    nivelPermissaoCadastrado: 'Nível de permissão cadastrado',
    alterarSenha: 'Alterar senha',
    cadastrarCredencial: 'Cadastrar credencial',
    caminhoPath: 'Caminho (Path)',
    console: 'Console',
    credencialAtiva: 'Credencial ativa',
    credencialCadastradaSucesso: 'Credencial cadastrada com sucesso.',
    credencialInativa: 'Credencial inativa',
    credencialAtualizadaSucesso: 'Credencial atualizada com sucesso.',
    credenciais: 'Credenciais',
    parceiros: 'Parceiros',
    dataAtualizacao: 'Data de atualização',
    dataCriacao: 'Data de criação',
    dnsFormatoInvalido: 'Informe "*" ou um domínio completo válido (ex.: api.telemedicina.ufsc.br).',
    dnsWildcards: 'DNS (Wildcards permitidos)',
    editarCredencial: 'Editar credencial',
    editarEtapas: 'Editar etapas',
    email: 'E-mail',
    emailResponsavel: 'E-mail do responsável técnico',
    erroSalvarCredencial: 'Não foi possível salvar a credencial.',
    erroListarParceiros: 'Não foi possível listar os parceiros.',
    erroSalvarParceiro: 'Não foi possível salvar o parceiro.',
    estados: 'Estados',
    estadosVinculo: 'Selecione os estados de vínculo',
    gerarSenha: 'Gerar senha',
    gestaoCredenciais: 'Gestão de Credenciais',
    gestaoParceiros: 'Gestão de Parceiros',
    habilitar: 'Habilitar',
    informacoesGerais: 'Informações gerais',
    instituicaoUnidade: 'Instituição/Unidade',
    confirmarRemocaoItem: 'Deseja realmente remover este item?',
    ipFormatoInvalido: 'Informe um IP válido no formato CIDR (ex.: 192.168.0.0/24).',
    intervalosIpCidr: 'Insira os intervalos de IP permitidos no formato CIDR',
    intervaloIp: 'Intervalo de IP (no formato CIDR)',
    ip: 'IP',
    login: 'Login',
    loginJaExiste: 'Este login já está em uso.',
    loginNome: 'Login ou nome',
    nivelPermissao: 'Nível de Permissão',
    nivelPermissaoEndpoint: 'Nível de permissão e endpoint',
    nome: 'Nome',
    nomeResponsavel: 'Nome do responsável técnico',
    pathFormatoInvalido: 'Informe um path válido (ex.: /administrativo).',
    seguranca: 'Segurança',
    segurançaIP: 'Segurança de IP',
    situacao: 'Situação',
    todos: 'Todos',
    urlParceiro: 'URL do parceiro',
};